import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ImpContainer, ImpPad, ImpText, colors, elevation, zIndex, } from '../..';
const offset = (arrow, mainAxisOffset) => arrow
    ? `calc(100% + ${mainAxisOffset + 5}px)`
    : `calc(100% + ${mainAxisOffset}px)`;
const arrowCss = (position, arrowOffset) => {
    const common = `
    content: '';
    position: absolute;
    width: 0;
    border-style: solid;
  `;
    switch (position) {
        case 'top':
            return `
          &::before {
            ${common}
            border-width: 0 5px 5px 5px;
            border-color: transparent transparent ${colors.background.backgroundInverse} transparent;
            top: 100%;
            left: calc(50% + ${arrowOffset}px);
            rotate: 180deg;
          }
        `;
        case 'bottom':
            return `
          &::before {
            ${common}
            border-width: 5px 5px 0 5px;
            border-color: ${colors.background.backgroundInverse} transparent transparent transparent;
            bottom: 100%;
            left: calc(50% + ${arrowOffset}px);
            transform: translateX(-50%);
            rotate: 180deg;
          }
        `;
        case 'right':
            return `
          &::before {
            ${common}
            border-width: 5px 0 5px 5px;
            border-color: transparent transparent transparent ${colors.background.backgroundInverse};
            top: calc(50% + ${arrowOffset}px);
            right: 100%;
            rotate: 180deg;
            transform: translateY(50%);
          }
        `;
        case 'left':
            return `
          &::before {
            ${common}
            border-width: 5px 5px 5px 0;
            border-color: transparent ${colors.background.backgroundInverse} transparent transparent;
            top: calc(50% + ${arrowOffset}px);
            left: 100%;
            rotate: 180deg;
            transform: translateY(50%);
          }
        `;
    }
};
const TooltipContent = styled(ImpContainer) `
  z-index: ${zIndex.tooltip};
  box-sizing: border-box;
  background-color: ${colors.background.backgroundInverse};
  box-shadow: ${elevation.primary3};
  border-radius: 4px;
  transition: all 0.3s;
  position: absolute;
  transform: translateX(-50%);
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.internalIsVisible ? 'auto' : 'none')};

  ${(props) => {
    return getTooltipPosition(props.position, props.arrow, props.mainAxisOffset, props.crossAxisOffset);
}}

  width: ${(props) => (props.width ? `${props.width};` : '100%;')}
    ${(props) => props.arrow && arrowCss(props.position, props.arrowOffset)};
`;
const TooltipContainer = styled.div `
  display: inline-block;
  position: relative;

  ${(props) => props.displayOnContentHover === true &&
    `&:hover ${TooltipContent} {
    opacity: 1;
    display: inline-block;
  }`}

  ${(props) => props.contentWidth && `width: ${props.contentWidth};`}
`;
function ImpTooltip({ arrow = false, arrowOffset = 0, centerArrowOnContent = true, crossAxisOffset = 0, displayOnContentHover = true, mainAxisOffset = 0, position = 'bottom', children, content, isVisible, title, width, contentWidth, }) {
    const tooltipRef = useRef(null);
    const containerRef = useRef(null);
    const [arrowOffsetAdjustment, setArrowOffsetAdjustment] = useState(0);
    const [internalIsVisible, setInternalIsVisible] = useState(isVisible);
    const [removeTimeout, setRemoveTimeout] = useState(null);
    useEffect(() => {
        setArrowOffsetAdjustment(centerArrowOnContent ? -crossAxisOffset : 0);
    }, [crossAxisOffset, centerArrowOnContent]);
    const handleMouseEnter = () => {
        if (removeTimeout) {
            clearTimeout(removeTimeout);
        }
        setInternalIsVisible(true);
    };
    const handleMouseLeave = () => {
        // setTimeout to allow fade out
        const removeTimeoutIdentifier = setTimeout(() => {
            setInternalIsVisible(isVisible);
            setRemoveTimeout(null);
        }, 300);
        setRemoveTimeout(removeTimeoutIdentifier);
    };
    useEffect(() => {
        if (isVisible) {
            setInternalIsVisible(true);
        }
    }, [isVisible]);
    return (React.createElement(TooltipContainer, { onAbort: handleMouseLeave, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ref: containerRef, "data-test-id": "tooltip-container", displayOnContentHover: displayOnContentHover, contentWidth: contentWidth },
        React.createElement(TooltipContent, { containerRef: tooltipRef, isVisible: isVisible, internalIsVisible: internalIsVisible, width: width, arrow: arrow, arrowOffset: arrowOffset + arrowOffsetAdjustment, mainAxisOffset: mainAxisOffset, crossAxisOffset: crossAxisOffset, position: position, dataTestId: "tooltip-content" },
            React.createElement(ImpPad, { padding: "6px 12px" }, title ? (React.createElement(ImpText, { typography: "body3", color: "white" }, title)) : (content))),
        children));
}
export default ImpTooltip;
function getTooltipPosition(position, arrow, mainAxisOffset, crossAxisOffset) {
    switch (position) {
        case 'top':
            return `
        bottom: ${offset(arrow, mainAxisOffset)};
        left: calc(50% + ${crossAxisOffset}px);
      `;
        case 'bottom':
            return `
        top: ${offset(arrow, mainAxisOffset)};
        left: calc(50% + ${crossAxisOffset}px);
      `;
        case 'right':
            return `left: ${offset(arrow, -mainAxisOffset)};
        top: calc(50% + ${crossAxisOffset}px);
        transform: translateY(-50%);`;
        case 'left':
            return `right: ${offset(arrow, -mainAxisOffset)};
        top: calc(50% + ${crossAxisOffset}px);
        transform: translateY(-50%);`;
        default:
            return '';
    }
}
//# sourceMappingURL=ImpTooltip.js.map